module.exports = __webpack_public_path__ + "img/weft_feeder.8988544e.svg";